jQuery(function($) {
  $(document).ready(main);

  function main () {
    loadingHandler();
    hamburgerHandler();
    searchHandler();
    playerOverlayHandler();
    mapFilterHandler();
  }

  function loadingHandler() {
    try {
      $('body').addClass('body-loaded');
      console.log('body-loaded');
    }
    catch (e) {
      console.log(e);
    }
  }

  function hamburgerHandler() {
    try {
      $('.header-hamburger').click(function () {
        $('body').toggleClass('hamburger-active');
        $('header .header-right, header .search-overlay-form').slideToggle();
      });
    }
    catch(e) {
      console.log(e);
    }
  }

  function searchHandler() {
    try {
      $('.search-submit').click(function () {
        $('.widget_search form').submit();
      });
    }
    catch(e) {
      console.log(e);
    }
  }

  function playerOverlayHandler() {
    if (!$.magnificPopup) {
      return;
    }

    $('.player-overlay-container').each(function () {
      var $container = $(this);
      var hasOverlay = $.contains($container, $('.player-overlay'));

      $container.css('position', 'relative');

      if (!hasOverlay) {
        $container.append('<div class="player-overlay"><img src="/content/uploads/2018/04/Play-Icon-1.svg"></div>');
      }

      $container.click(function () {
        var $video = $container.find('iframe');
        var src;
        var contentType;

        if (!$video[0]) {
          src         = $container;
          contentType = 'inline';
        }
        else {
          src         = $video.attr('src');
          contentType = 'iframe';

          appendAutoplay();
        }

        $.magnificPopup.open({
          items:{
            src: src
          },
          iframe: {
            patterns: {
              vimeo: {
                index: 'vimeo.com/video',
                id: '/',
                src: '//player.vimeo.com/video/%id%'
              }
            },
            markup: '<div class="mfp-iframe-scaler">'+
            '<div class="mfp-close"></div>'+
            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
          '</div>',
            srcAction: 'iframe_src' // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
          },
          type: contentType
        });

        function appendAutoplay() {
          if (!src) {
            return;
          }

          if (src.includes('?')) {
            src += '&autoplay=1';
          }
          else {
            src += '?autoplay=1';
          }
        }
      });
    });
  }

  function mapFilterHandler() {
    var $fosterFilter = $('.foster-filter');
    var $resFilter    = $('.residential-filter');
    var $buttons      = $('.map-filters .fl-button');
    var $fosterMap    = $('.foster-map');
    var $resMap       = $('.residential-map');

    $buttons.click(function (ev) {
      var $active = $('.map-filters .active-filter');
      var $target = $(ev.currentTarget);

      if($.contains($active, $target)) {
        console.log('active is active');
        return
      }

      if ($active.is($fosterFilter)) {
        console.log("active is fosterfilter");
        $fosterMap.removeClass('active-map');
        $resMap.addClass('active-map');
        $fosterFilter.removeClass('active-filter');
        $resFilter.addClass('active-filter');
      }
      else {
        console.log("active is resfilter");
        $resMap.removeClass('active-map');
        $fosterMap.addClass('active-map');
        $resFilter.removeClass('active-filter');
        $fosterFilter.addClass('active-filter');
      }
    });
  }
});
